module.exports = __webpack_public_path__ + "static/media/react-js.b7723ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/react-js.png
// module id = 617
// module chunks = 157